import { render, staticRenderFns } from "./ApparelAddToCartAreaSkeleton.vue?vue&type=template&id=7896181c&scoped=true&"
import script from "./ApparelAddToCartAreaSkeleton.vue?vue&type=script&lang=ts&"
export * from "./ApparelAddToCartAreaSkeleton.vue?vue&type=script&lang=ts&"
import style0 from "./ApparelAddToCartAreaSkeleton.vue?vue&type=style&index=0&id=7896181c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7896181c",
  null
  
)

export default component.exports